// extracted by mini-css-extract-plugin
export default {"copybutton":"AddBotWizard_copybutton__xTtne","selectchatbutton":"AddBotWizard_selectchatbutton__-ONEi"};